export default "__VITE_ASSET__754a9f2e__"